const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJustice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496.159 496.159",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48A1AF"
    },
    d: "M248.083,0.003C111.071,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.083,248.07 c137.006,0,248.076-111.069,248.076-248.07C496.159,111.062,385.089,0.003,248.083,0.003z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.03,
    y: 137.849,
    style: {
      fill: "#D8DBBA"
    },
    width: 10.938,
    height: 202.92
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DBBA"
    },
    d: "M268.273,366.721c0-46.279-19.353-45.438-19.353-45.438s-19.353-0.842-19.353,45.438 c0,0,5.049,17.67-78.253,17.67v8.414h195.211v-8.414C263.226,384.391,268.273,366.721,268.273,366.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DBBA"
    },
    d: "M248.5,103.353c-4.628,0-10.813,9.808-10.813,31.73s22.467,21.922,22.467,0 S253.128,103.353,248.5,103.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6D68"
    },
    d: "M369.95,135.295c-1.718-0.696-3.685,0.13-4.385,1.853l-45.437,111.909 c-0.7,1.723,0.129,3.686,1.852,4.385c0.415,0.169,0.843,0.248,1.266,0.248c1.328,0,2.588-0.793,3.119-2.1l45.437-111.91 C372.502,137.957,371.673,135.994,369.95,135.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6D68"
    },
    d: "M431.964,249.057l-45.437-111.909c-0.7-1.723-2.667-2.549-4.385-1.853 c-1.723,0.699-2.552,2.662-1.853,4.385l45.438,111.91c0.53,1.307,1.79,2.1,3.119,2.1c0.422,0,0.851-0.079,1.266-0.248 C431.834,252.742,432.663,250.779,431.964,249.057z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E5CF"
    },
    d: "M319.32,248.22c0,0,0.842,39.967,57.218,39.967c56.375,0,56.375-39.967,56.375-39.967H319.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DBBA"
    },
    d: "M388.085,107.144c0.004,0.034,0.002,0.069,0.005,0.104c-2.276-2.316-5.662-3.79-9.449-3.79 c-6.854,0-12.411,4.812-12.411,10.745c0,5.936,5.557,10.746,12.411,10.746c0.166,0,0.327-0.016,0.491-0.021 c-2.809,1.693-6.088,2.686-9.606,2.686c-5.189,0-16.191-6.592-34.779-6.592c-14.725,0-44.584,8.835-86.666,8.835v13.884 c33.729,0,64.768-9.771,79.655-10.236c27.542-0.86,35.9,4.207,44.034,7.011c8.134,2.805,23.139-4.189,23.139-16.969 C394.908,117.136,392.299,111.335,388.085,107.144z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6D68"
    },
    d: "M176.031,249.057l-45.437-111.909c-0.7-1.723-2.667-2.549-4.385-1.853 c-1.723,0.699-2.552,2.662-1.853,4.385l45.438,111.91c0.531,1.307,1.79,2.1,3.119,2.1c0.422,0,0.851-0.079,1.266-0.248 C175.901,252.742,176.73,250.779,176.031,249.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6D68"
    },
    d: "M114.018,135.295c-1.718-0.696-3.685,0.13-4.385,1.853L64.196,249.057 c-0.7,1.723,0.129,3.686,1.852,4.385c0.415,0.169,0.843,0.248,1.266,0.248c1.328,0,2.588-0.793,3.119-2.1l45.437-111.91 C116.569,137.957,115.74,135.994,114.018,135.295z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E5CF"
    },
    d: "M63.247,248.22c0,0,0,39.967,56.375,39.967c56.376,0,57.217-39.967,57.217-39.967H63.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DBBA"
    },
    d: "M161.413,121.023c-18.588,0-29.589,6.592-34.778,6.592c-3.519,0-6.798-0.992-9.606-2.686 c0.164,0.005,0.325,0.021,0.491,0.021c6.854,0,12.411-4.811,12.411-10.746c0-5.934-5.558-10.745-12.411-10.745 c-3.787,0-7.174,1.474-9.449,3.79c0.003-0.035,0.001-0.07,0.005-0.104c-4.214,4.19-6.824,9.991-6.824,16.403 c0,12.779,15.006,19.773,23.14,16.969s16.492-7.871,44.034-7.011c14.887,0.465,45.926,10.236,79.655,10.236v-13.884 C205.998,129.858,176.139,121.023,161.413,121.023z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustice);
export default __webpack_public_path__ + "static/media/justice.ad33d469aa0c6ec6c0c8e2431b548126.svg";
export { ForwardRef as ReactComponent };